/* eslint-disable react/prop-types */
import React from 'react';
import { Stack, Typography, Box, Avatar } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SecurityIcon from '@mui/icons-material/Security';
import AutorenewIcon from '@mui/icons-material/Autorenew';

export default function PaymentInfo({ userName, userEmail, userAvatar, currentBalance, bundle }) {
  return (
    <Stack spacing={2}>
      <Typography variant="h6" sx={{ fontWeight: '600', color: '#007d7d' }}>
        Purchase Confirmation
      </Typography>

      {/* صورة المستخدم + الاسم والإيميل */}
      <Stack direction="row" spacing={2} alignItems="center">
        <Avatar alt={userName} src={userAvatar || ''} sx={{ bgcolor: '#007d7d' }}>
          {userName?.charAt(0).toUpperCase()}
        </Avatar>
        <Box>
          <Typography variant="body1" sx={{ fontWeight: '600' }}>
            {userName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {userEmail}
          </Typography>
        </Box>
      </Stack>

      {/* خط فاصل */}
      <Box sx={{ borderBottom: '1px solid #ddd', my: 2 }} />

      {/* الرصيد الحالي والرصيد بعد الدفع */}
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} alignItems="center">
          <AccountBalanceWalletIcon sx={{ color: '#007d7d' }} fontSize="small" />
          <Typography variant="body1" color="text.secondary">
            Current Balance: <strong>{currentBalance} Coins</strong>
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center">
          <TrendingUpIcon sx={{ color: 'green' }} fontSize="small" />
          <Typography variant="body1" color="text.secondary">
            After Payment: <strong>{currentBalance + bundle.coins} Coins</strong>
          </Typography>
        </Stack>
      </Stack>

      {/* الملاحظات */}
      <Stack spacing={1} sx={{ mt: 2 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <AutorenewIcon sx={{ color: '#007d7d' }} fontSize="small" />
          <Typography variant="body2" color="text.secondary">
            No need to pay every month
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center">
          <SecurityIcon sx={{ color: 'green' }} fontSize="small" />
          <Typography variant="body2" color="text.secondary">
            The purchase process is safe and guaranteed
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
